import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiClient, setAuthToken, formatApiError } from "@/lib/api";
import logo from "@/assets/logo.png";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await apiClient.post("/admin/login", { email, password });
      localStorage.setItem("ferguson_admin_token", data.access_token);
      setAuthToken(data.access_token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-deep flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-2xl border border-gold/15 bg-deep-card p-8">
        <div className="flex flex-col items-center mb-6">
          <img src={logo} alt="Ferguson's logo" className="h-16 w-auto mb-3" />
          <div className="flex items-center gap-2 text-gold">
            <Lock size={16} />
            <span className="font-display font-semibold">Admin Portal</span>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="admin_email">Email</Label>
            <Input
              id="admin_email"
              type="email"
              required
              data-testid="admin-login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5"
            />
          </div>
          <div>
            <Label htmlFor="admin_password">Password</Label>
            <Input
              id="admin_password"
              type="password"
              required
              data-testid="admin-login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-btn"
            className="w-full bg-gold hover:bg-gold-hover disabled:opacity-60 text-[#0A140F] font-display font-semibold text-sm px-6 py-3 rounded-full flex items-center justify-center gap-2 transition-colors"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
